import { Component } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { Router } from '@angular/router';

@Component({
  selector: 'pre-verification-component',
  templateUrl: '../sharedTemplates/pre-verification.component.html',
})
export class PreVerificationComponent {
  constructor(public _uiHelper: UiHelper, private _router: Router) {}
  handleCloseAccountMenu() {
    this._uiHelper.b3000SetAcountMobileState('close');

    this._router.navigate(['/document']);
  }
}
